module.exports = __webpack_public_path__ + "assets/img/google_play.0b2234ab.png";